import Typography, { TypographyProps } from '@mui/material/Typography';

export const MoreRecommendationsTypography = (props: TypographyProps) => {
  return <Typography {...props}>Want more recommendations?</Typography>;
};
